import {Component} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {kanUsersService} from "../../../services/services/users";

@Component({
  selector: 'kan-login',
  templateUrl: './component.html',
  styleUrls: ['./component.scss']
})
export class kanLogin {
    public identity: {
    email: string,
    password: string,
    remember: boolean
  } = {
    email: '',
    password: '',
    remember: true
  };

  constructor(private userService: kanUsersService, private stateService: StateService) {

  }

    public login(event): void {
    this.userService.login(this.identity)
      .then((user) => {
        this.stateService.go('app.home');
      })
  }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/login/component.ts